export default function knotch() {
    return `
    <script type="text/javascript" src="https://www.knotch-cdn.com/unit/latest/knotch.min.js" async></script>
  `;
}
